import React from 'react';
import CardBackground from '../CardBackground';
import { resolveImageUrl, DEFAULT_LOGO } from '../../utils/imageDefaults';
import { resolveTemplateColors } from '../../utils/templateColors';
import { getSurfaceClassName } from '../../utils/cardSurface';
import { PREVIEW_CARD_DEMO } from '../../utils/previewDemo';

const WalletCardPreview = ({ user, template }) => {
  const colors = resolveTemplateColors(template || {});
  const cardStyle = template?.cardStyle || 'plastic';
  const storeBg = resolveImageUrl(user?.backgroundUrl, null);
  const logoUrl = resolveImageUrl(user?.logoUrl, DEFAULT_LOGO);
  const demo = PREVIEW_CARD_DEMO;

  return (
    <div className="admin-preview-block admin-preview-block--wallet">
      <p className="admin-preview-caption admin-preview-caption--light">В кошельке</p>
      <div className="wallet-preview-scene">
      <button type="button" className={`wallet-card wallet-card--preview ${getSurfaceClassName(cardStyle)}`}>
        <CardBackground
          mainColor={colors.mainColor}
          imageUrl={storeBg}
          cardStyle={cardStyle}
          backgroundPattern="solid"
          allowPhoto
        />
        <div className="wallet-card-body">
          <div className="wallet-card-header">
            <span className="wallet-card-shop" style={{ color: colors.textColor }}>
              {user?.accountName || 'Магазин'}
            </span>
            <img src={logoUrl} className="wallet-card-logo" alt="" />
          </div>
          <div className="wallet-card-balance-block">
            <span className="wallet-card-balance-label" style={{ color: colors.labelColor }}>Баланс</span>
            <span className="wallet-card-balance" style={{ color: colors.textColor }}>
              {demo.balance.toLocaleString('ru-RU')} ₽
            </span>
          </div>
        </div>
      </button>
      </div>
    </div>
  );
};

export default WalletCardPreview;
